// App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from 'react';
import Homepage from './components/homepage.jsx';
import Kehadiran from './components/kehadiran.jsx';
import Login from './components/login.jsx';
import Kepulangan from './components/kepulangan.jsx';
// import Admin from './components/admin.jsx';
import Menu from './components/menu.jsx';
import StartGames from "./components/startgame.jsx";
import Games from "./components/game.jsx";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/menu/:day" element={<Menu />} />
        <Route path="/kehadiran/:day" element={<Kehadiran />} />
        <Route path="/kepulangan/:day" element={<Kepulangan />} />
        <Route path="/startgames/:day" element={<StartGames />} />
        <Route path="/games/:day" element={<Games />} />
      </Routes>
    </Router>
  );
}

export default App;